import { render, staticRenderFns } from "./SQLFormatter.vue?vue&type=template&id=2f73f880"
import script from "./SQLFormatter.vue?vue&type=script&lang=js"
export * from "./SQLFormatter.vue?vue&type=script&lang=js"
import style0 from "./SQLFormatter.vue?vue&type=style&index=0&id=2f73f880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports